<template>
  <el-container class="pagination-list app-version-list">
    <el-main>
      <div class="content">
       <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%">
        <template  v-for="(col,index) in cols" >
          <el-table-column :key="index"
           :prop="col.prop" :label="col.label" align="center" :formatter="formatter"  show-overflow-tooltip>
          </el-table-column>
        </template>
          <el-table-column
           fixed="left" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
     <el-dialog
      title="APP版本管理"
      v-if="version.dialogVisible"
      :visible.sync="version.dialogVisible"
      width="70%"
      center>
      <app-version :id="version.id" @closeDialog="closeDialog"></app-version>
    </el-dialog>
  </el-container>
</template>

<script>
import AppVersion from './app-version.vue'
export default {
  name: 'appVersionList',
  data () {
    return {
      loading: false,
      items: [],
      cols: [
        { prop: 'appVersion', label: '版本号' },
        { prop: 'appVersion', label: '版本名称' },
        { prop: 'appType', label: '系统类型' },
        { prop: 'isUse', label: '是否可用' },
        { prop: 'isShow', label: ' 是否展示' },
        { prop: 'appApkPath', label: ' 链接' },
        { prop: 'createTime', label: '创建时间' },
        { prop: 'updateTime', label: '更新时间' },
        { prop: 'versionDescription', label: '更新信息' },
        { prop: 'mandatoryUpgrade', label: '是否升级' },
        { prop: 'appStatus', label: ' 打包状态' }
      ],
      version: {
        dialogVisible: false,
        id: ''
      }

    }
  },
  components: {
    AppVersion
  },
  created () {
    this.getTableData()
  },
  methods: {
    formatter (row, column) {
      var data = row[column.property]

      if (column.property === 'appType') {
        return data === 1 ? 'android' : 'ios'
      }
      if (column.property === 'isUse') {
        return data ? '是' : '否'
      }
      if (column.property === 'isShow') {
        return data ? '是' : '否'
      }
      if (column.property === 'mandatoryUpgrade') {
        return data ? '是' : '否'
      }

      if (column.property === 'appStatus') {
        switch (data) {
          case '1':
            data = '打包成功'
            break
          case '0':
            data = '打包失败'
            break
          case '3':
            data = '打包中'
        }
      }
      return data
    },
    editRow (row) {
      this.version.dialogVisible = true
      this.version.id = row.id
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      this.$axios.get('/mobile-api/version')
        .then((res) => {
          this.items = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    closeDialog (type) {
      this.version.dialogVisible = false
      if (type === 'save') {
        this.getTableData()
      }
    }

  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';
  .app-version-list.pagination-list {
    .content {
    padding-left: 18px;
    padding-right: 18px;
    height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/appDesign/app-version-list.vue